import { useEffect, useState } from "react";

export function CopyButton({ value, label = "Copy" }: { value: string; label?: string }) {
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (!copied) {
      return;
    }
    const timer = window.setTimeout(() => setCopied(false), 2000);
    return () => window.clearTimeout(timer);
  }, [copied]);

  async function copy() {
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
    } catch {
      window.prompt("Copy this:", value);
    }
  }

  return (
    <button type="button" className="btn btn-secondary btn-sm" onClick={() => void copy()}>
      <span aria-live="polite">{copied ? "Copied" : label}</span>
    </button>
  );
}
